import React from 'react';
import { DURATION_OPTIONS } from '../../lib/constants';
import { cn } from '../../lib/utils';
interface StepPriceDurationProps {
  priceEur: string;
  contractDuration: string;
  onChange: (patch: {
    priceEur?: string;
    contractDuration?: string;
  }) => void;
}
export function StepPriceDuration({
  priceEur,
  contractDuration,
  onChange
}: StepPriceDurationProps) {
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-10" data-id="element-2708">
      <div data-id="element-2709">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2710">
          Preț și durată
        </h2>
        <p className="text-sm text-light-3" data-id="element-2711">Cât ceri și pe ce perioadă.</p>
      </div>

      <div data-id="element-2712">
        <label className="block text-xs font-medium text-light-3 uppercase tracking-wider mb-2" data-id="element-2713">
          Preț lunar
        </label>
        <div className="relative max-w-xs" data-id="element-2714">
          <input type="number" value={priceEur} onChange={e => onChange({
          priceEur: e.target.value
        })} placeholder="450" className="w-full h-12 pl-4 pr-10 rounded-xl bg-dark-2 border border-dark-4 text-base text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2715" />
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-light-3 pointer-events-none" data-id="element-2716">
            €/lună
          </span>
        </div>
      </div>

      <div data-id="element-2717">
        <h3 className="text-xs font-medium text-light-3 uppercase tracking-wider mb-3" data-id="element-2718">
          Durată contract
        </h3>
        <div className="flex flex-wrap gap-2" data-id="element-2719">
          {DURATION_OPTIONS.map((opt: any) => <button key={opt.value} type="button" onClick={() => onChange({
          contractDuration: opt.value
        })} className={cn('h-11 px-5 rounded-full text-sm font-medium border transition-colors cursor-pointer', contractDuration === opt.value ? 'bg-lime-1 border-lime-1 text-dark-1' : 'bg-dark-2 border-dark-4 text-light-2 hover:border-light-3')} data-id="element-2720">
              {opt.label}
            </button>)}
        </div>
      </div>
    </div>;
}